import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import PlatformWldlUploadedWorks from '@/types/table/platformWldlUploadedWorks';
import { PlatformUserData } from '@/api/generated/platformUserController';
import { PlatformWldlUserData } from '@/api/generated/platformWldlUserController';
import { PlatformWldlUserCertificateData } from '@/api/generated/platformWldlUserCertificateController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface PlatformWldlUploadedWorksData extends PlatformWldlUploadedWorks {
  platformUser?: PlatformUserData;
  platformWldlUser?: PlatformWldlUserData;
  platformWldlUserCertificate?: PlatformWldlUserCertificateData;
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class PlatformWldlUploadedWorksController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<PlatformWldlUploadedWorksData>>(API_CONTEXT + '/app/platformWldlUploadedWorks/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<PlatformWldlUploadedWorksData>(API_CONTEXT + '/app/platformWldlUploadedWorks/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/platformWldlUploadedWorks/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/platformWldlUploadedWorks/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/platformWldlUploadedWorks/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformWldlUploadedWorks/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformWldlUploadedWorks/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformWldlUploadedWorks/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformWldlUploadedWorks/deleteBatch', params, httpOptions);
  }
}
